import React from 'react';
import { useGlobal } from 'reactn';
import {
    AppBar,
    Toolbar,
    IconButton,
    Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import MenuIcon from '@material-ui/icons/Menu';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import Grid from '@material-ui/core/Grid';
import ConceptChooser from '../ConceptChooser/ConceptChooser';
import { Logout } from '../../components/Authenticate/Authenticate';

const drawerWidth = 255;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        backgroundColor: 'white',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        boxShadow: '0px 2px 6px -3px rgb(0 0 0 / 20%)'
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    logOutButton: {
        // backgroundColor: 'transparent',
        // borderRadius: 3,
        // border: 0,
        // color: 'white',
        // fontSize: 14,
        // height: 'auto',
        // padding: '0 10px 0 0',
        // '&:hover': {
        //     backgroundColor: 'transparent',
        //     color: '#DBDBDB'
        // }
    },
    headerActiveUserAndConcept: {
        borderLeft: 'solid 1px #EEEEF4',
        paddingLeft: 10
    },
    headerConceptChooser: {
        // borderLeft: 'solid 1px #EEEEF4',
        paddingLeft: '12px !important'
    }
}));

export default function Header() {
    const classes = useStyles();
    // const [activeUser] = useGlobal('activeUser');
    const [sidebarOpen, setSidebarOpen] = useGlobal('sidebarOpen');
    // const [activeConcept] = useGlobal('activeConcept');

    const handleSidebarOpen = () => {
        setSidebarOpen(true);
    };

    return (
        <div>
            <AppBar
                position="absolute"
                elevation={1}
                className={clsx(classes.appBar, sidebarOpen && classes.appBarShift)}
            >
                <Toolbar className={classes.toolbar}>
                    <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
                        <Grid item>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="Open drawer"
                                onClick={handleSidebarOpen}
                                className={clsx(
                                    classes.menuButton,
                                    sidebarOpen && classes.menuButtonHidden,
                                )}
                            >
                                <MenuIcon />
                            </IconButton>
                        </Grid>
                        <Grid item>

                            <Button
                                size="small"
                                endIcon={<LogoutIcon />}
                                onClick={Logout}
                            >Log out</Button>

                            {/*{activeUser && (*/}
                            {/*    <span className={classes.headerActiveUserAndConcept}>*/}
                            {/*        {activeConcept && activeConcept.name ? `${activeUser.name}, ${activeConcept.name}` : `${activeUser.name}`}*/}
                            {/*    </span>*/}
                            {/*)}*/}
                        </Grid>
                        <Grid item>
                            <ConceptChooser variant="standard" className={classes.headerConceptChooser} />
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </div>
    );
}
